import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { baseUrl } from '../../../config/route-entry-point';

import NewsList from '../../../modules/news/components/table/list';

lessRequire('modules/dashboard/components/news.less');

const News = ({
	data,
	openedNewsId,
	openedNewsOffers,
	toggleNews,
	newsTypesEnum,
	intl
}) => (
	<div className="latest-news">
		<div className="latest-news__items">
			{ <NewsList
				rows={data}
				openedNewsId={openedNewsId}
				openedNewsOffers={openedNewsOffers}
				showMore={null}
				toggleNews={toggleNews}
				newsTypesEnum={newsTypesEnum}
				intl={intl}
			/> }
		</div>

		<Link
			to={baseUrl(`news/`)}
			className="button list-icon yellow-border font-proxima-nova-bold">
			{intl('Все новости')}
		</Link>

	</div>
);

News.propTypes = {
	data: PropTypes.array,
	openedNewsId: PropTypes.string,
	openedNewsOffers: PropTypes.array,
	toggleNews: PropTypes.func,
	newsTypesEnum: PropTypes.object,
	intl: PropTypes.func
};

export default News;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/dashboard/components/news.js